import { createTheme } from '@material-ui/core/styles';
import { Colors, Metrics } from './index';

const { xs, sm, md, lg, xl } = Metrics.breakpoints;

const theme = createTheme({
  spacing: 5,
  breakpoints: {
    values: {
      xs,
      sm,
      md,
      lg,
      xl,
    },
  },
  palette: {
    primary: {
      type: 'dark',
      main: Colors.lightGrey,
      dark: Colors.lightGrey,
    },
    secondary: {
      main: Colors.lightBlue,
    },
    text: {
      primary: Colors.white,
      secondary: Colors.white,
    },
    background: {
      default: Colors.black,
    },
    action: {
      disabled: Colors.disabledGrey,
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: 'Open Sans',
    h2: {
      fontSize: 18,
      fontWeight: 700,
      lineHeight: 1.6,
      textTransform: 'uppercase',
    },
  },
  overrides: {
    MuiGrid: {
      'spacing-xs-5': {
        width: '100%',
        margin: 0,
      },
    },
    MuiPaper: {
      root: {
        backgroundColor: Colors.hoverGrey,
        color: Colors.white,
      },
    },
    MuiButton: {
      iconSizeMedium: {
        '& *:first-child': {
          fontSize: 16,
        },
      },
    },
    MuiInput: {
      underline: {
        '&:before': {
          borderBottom: `1px solid ${Colors.underlineGrey}`,
        },
      },
    },
    MuiInputBase: {
      root: {
        '&.Mui-disabled': {
          cursor: 'default',
          pointerEvents: 'auto',
          color: Colors.disabledGrey,
        },
      },
      input: {
        marginLeft: 15,
        color: Colors.white,
        '&.Mui-disabled': {
          pointerEvents: 'auto',
        },
      },
    },
    MuiPopover: {
      paper: {
        color: Colors.black,
        background: Colors.white,
      },
    },
    MuiAppBar: {
      colorPrimary: {
        color: Colors.white,
        backgroundColor: Colors.black,
      },
    },
    MuiDialogActions: {
      root: {
        padding: 20,
      },
    },
    MuiDrawer: {
      paperAnchorDockedLeft: {
        borderRight: 'none',
      },
    },
    MuiTableBody: {
      root: {
        '&:not(:first-child)': {
          cursor: 'pointer',
        },
      },
    },
    MuiTableRow: {
      root: {
        '&:nth-child(odd)': {
          backgroundColor: Colors.navBackgroundGrey,
        },
        '&:nth-child(even)': {
          backgroundColor: Colors.hoverGrey,
        },
        '&:hover': {
          '& .MuiTableCell-body, & .MuiInputBase-input, & .MuiCheckbox-root': {
            color: Colors.blue,
          },
          '& .MuiButtonBase-root.hubNotArmedButton:not(.Mui-disabled)': {
            color: Colors.black,
            border: `1px solid ${Colors.black}`,
            '&:hover': {
              color: Colors.white,
              border: `1px solid ${Colors.disabledGrey}`,
            },
          },
          '& .rc-time-picker-input:not(&disabled) ': {
            border: `2px solid ${Colors.blue}`,
            color: Colors.blue,
          },
          backgroundColor: Colors.white,
        },
        '&:last-child': {
          borderRadius: '0 0 4px 4px',
        },
        '&.MuiTableRow-head': {
          backgroundColor: Colors.hoverGrey,
        },
      },
    },
    MuiTableSortLabel: {
      root: {
        color: Colors.lightGrey,
        textDecoration: 'underline',
        '& .MuiTableSortLabel-active': {
          color: Colors.lightGrey,
        },
        '&:hover, & .MuiTableSortLabel-active:hover': {
          color: Colors.orange,
        },
        justifyContent: 'space-between',
        width: '100%',
      },
    },

    MuiTableCell: {
      root: {
        borderBottom: 'none',
        padding: 0,
        fontSize: 16,
      },
      body: {
        color: Colors.white,
      },
      head: {
        color: Colors.orange,
      },
    },
    MuiToolbar: {
      root: {
        background: Colors.hoverGrey,
      },
      regular: {
        borderRadius: 4,
      },
    },
    MuiTablePagination: {
      toolbar: {
        borderRadius: '0 0 4px 4px',
      },
    },
    MuiIconButton: {
      root: {
        color: Colors.white,
      },
    },
    MuiSelect: {
      icon: {
        color: Colors.white,
      },
      selectMenu: {
        textAlign: 'left',
        marginLeft: 15,
      },
    },
    MuiFormLabel: {
      root: {
        color: Colors.lightGrey,
        fontSize: 16,
        fontStyle: 'italic',
        '&$disabled': {
          color: Colors.disabledGrey,
        },
      },
    },
    MuiInputLabel: {
      shrink: {
        transform: 'translate(0, 1.5px) scale(0.857)',
        fontStyle: 'normal',
      },
      root: {
        '&$disabled': {
          color: Colors.disabledGrey,
        },
      },
    },
    MuiFlatPagination: {
      root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      },
    },
    MuiFlatPageButton: {
      sizeSmallEnd: {
        paddingLeft: 0,
        paddingRight: 0,
      },
      sizeSmallCurrent: {
        paddingLeft: 8,
        paddingRight: 8,
      },
      sizeSmallStandard: {
        paddingLeft: 8,
        paddingRight: 8,
      },
      sizeSmall: {
        minWidth: 8,
      },
    },
  },
});

export default theme;
